import { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";

const AnimatedCounter = ({
  from = 0,
  to,
  duration = 2,
  prefix = "",
}) => {
  const [value, setValue] = useState(from);

  useEffect(() => {
    const controls = animate(from, to, {
      duration,
      onUpdate: (latest) => {
        setValue(Math.floor(latest));
      },
    });

    return () => controls.stop();
  }, [from, to, duration]);

  return (
    <motion.span>
      {prefix}{value}
    </motion.span>
  );
};

export default AnimatedCounter;
